<template>
  <div v-if="signedIn" class="kot-notes">
    <button
      type="button"
      class="kot-notes__btn"
      title="Notifications"
      aria-label="Notifications"
      :aria-expanded="open ? 'true' : 'false'"
      @click.stop="toggle"
    >
      <i class="fas fa-bell" aria-hidden="true"></i>
      <span v-if="items.length" class="kot-notes__count">{{ badge }}</span>
    </button>
    <div v-if="open" class="kot-notes__panel" @click.stop>
      <div class="kot-notes__head">Notifications</div>
      <p v-if="!items.length" class="kot-notes__empty">No new notifications</p>
      <button
        v-for="item in items"
        :key="item.id"
        type="button"
        class="kot-notes__item"
        @click="openItem(item)"
      >
        <strong>{{ item.title }}</strong>
        <span>{{ item.message }}</span>
        <small>{{ when(item.createdAt) }}</small>
      </button>
    </div>
  </div>
</template>

<script>
import http from '@/plugins/axios';

export default {
  data: () => ({
    items: [],
    open: false,
    timer: null,
  }),
  computed: {
    signedIn() {
      return Boolean(localStorage.getItem('jhms_token'));
    },
    badge() {
      return this.items.length > 9 ? '9+' : String(this.items.length);
    },
  },
  created() {
    this.load();
    this.timer = setInterval(this.load, 15000);
    document.addEventListener('click', this.close);
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
    document.removeEventListener('click', this.close);
  },
  methods: {
    when(value) {
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return '';
      return date.toLocaleString();
    },
    close() {
      this.open = false;
    },
    toggle() {
      this.open = !this.open;
      if (this.open) this.load();
    },
    load() {
      if (!this.signedIn) return;
      http
        .get('hms/web/kot-notifications')
        .then((res) => {
          this.items = Array.isArray(res.data) ? res.data : [];
        })
        .catch(() => {});
    },
    openItem(item) {
      this.items = this.items.filter((row) => row.id !== item.id);
      this.open = false;
      http.post('hms/web/kot-notifications/' + item.id + '/seen').catch(() => {});
      if (item.link && this.$route.fullPath !== item.link) {
        this.$router.push(item.link);
      }
    },
  },
};
</script>

<style scoped>
.kot-notes {
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-right: 8px;
}

.kot-notes__btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 999px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #1e293b;
  cursor: pointer;
}

.kot-notes__count {
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  border-radius: 999px;
  background: #dc2626;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 18px;
}

.kot-notes__panel {
  position: absolute;
  top: 44px;
  right: 0;
  z-index: 10060;
  width: 320px;
  max-height: 420px;
  overflow: auto;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.16);
  text-align: left;
}

.kot-notes__head {
  padding: 12px 14px;
  font-weight: 700;
  color: #0f172a;
  border-bottom: 1px solid #e2e8f0;
}

.kot-notes__empty {
  margin: 0;
  padding: 16px 14px;
  color: #64748b;
  font-size: 13px;
}

.kot-notes__item {
  display: block;
  width: 100%;
  padding: 12px 14px;
  border: 0;
  border-bottom: 1px solid #f1f5f9;
  background: #fff;
  text-align: left;
  cursor: pointer;
}

.kot-notes__item:hover {
  background: #f8fafc;
}

.kot-notes__item strong,
.kot-notes__item span,
.kot-notes__item small {
  display: block;
}

.kot-notes__item strong {
  color: #0f172a;
  font-size: 14px;
}

.kot-notes__item span {
  margin-top: 2px;
  color: #334155;
  font-size: 13px;
}

.kot-notes__item small {
  margin-top: 4px;
  color: #64748b;
  font-size: 11px;
}
</style>
